import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import OnboardingToolTip from '../BuildingBlocks/OnboardingToolTip';
import { NO_PRODUCT } from '../messages';

const useStyles = makeStyles((theme: any) => ({
  noProductTip: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'center',
  },
}));

export default function NoProduct({ header = 'No product?' }) {
  const classes = useStyles();

  return (
    <div className={classes.noProductTip}>
      <OnboardingToolTip summary={header} tooltip={NO_PRODUCT} />
    </div>
  );
}
